import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteCustomerReference: (
  fetchContext: FetchContext,
  customerReferenceId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, customerReferenceId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/customer-references/${customerReferenceId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete customer reference'));
